import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


import { ShActionItemComponent } from '../action-item/action-item.component';
import { ActionItem } from '../action-item/entities/action-item.entity';
import { ShIconLinkComponent } from '../icon-link/icon-link.component';
import { IconSize } from '../icon/entities/icon-sizes.entity';
import { ShIconModule } from '../icon/icon.module';
import { InlineDescriptionListItem } from '../inline-description-list/entities/inline-description-list-item.entity';
import { ShInlineDescriptionListComponent } from '../inline-description-list/inline-description-list.component';
import { NavigationItem } from '../navigation-item/entities/navigation-item.entity';

@Component({
    standalone: true,
    selector: 'sh-page-header',
    templateUrl: './page-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShInlineDescriptionListComponent, ShActionItemComponent, ShIconLinkComponent, ShIconModule]
})
export class ShPageHeaderComponent {
    iconSize: typeof IconSize = IconSize;

    @Input() title!: string;
    @Input() thumbnailSrc: string | undefined;
    @Input() icon: string | undefined;
    @Input() contextItems: InlineDescriptionListItem[] | undefined;
    @Input() primaryNavigationItems: NavigationItem[] | undefined;
    @Input() secondaryNavigationItems: NavigationItem[] | undefined;
    @Input() actionItems: ActionItem[] | undefined;
    @Input() isSubsection = false;
    @Input() fullWithContext: boolean = false;
}
